export default {"src":"/_next/static/media/feedback-star.16773b47.svg","height":16,"width":18,"blurWidth":0,"blurHeight":0};